// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"mVysuTQ","title":"KQ4yuTW","italic":"RZTFGbD"};